import { TranslationKeys as CoreTranslations } from '@pascal/pascal-core';

const GameTranslationKeys = {
  TopWinners: 'TOP_WINNERS',
  History: 'HISTORY',
  Result: 'RESULT',
  LiveBets: 'LIVE_BETS',
  Statistics: 'STATISTICS',
  Bet: 'BET',
  Info: 'INFO',
  FairnessModalTitle: 'FAIRNESS',
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  BetForNextRound: 'BET_FOR_NEXT_ROUND',
  Time: 'TIME',
  GameId: 'GAME_ID',
  Count: 'COUNT',
  TotalBet: 'TOTAL_BET',
  Game: 'GAME',
  PlayForReal: 'PLAY_FOR_REAL',
  Music: 'MUSIC',
  Sound: 'SOUND',
  WinterMode: 'WINTER_MODE',
  BlackMode: 'BLACK_MODE',
  PlayerId: 'PLAYER_ID',
  BetType: 'BET_TYPE',
  LastRounds: 'LAST_ROUNDS',
  Balance: 'BALANCE',
  All: 'ALL',
  Win: 'WIN',
  Lose: 'LOSE',
  MaximumWin: 'MAXIMUM_WIN',
  MinimumBet: 'MINIMUM_BET',
  MaximumBet: 'MAXIMUM_BET',
  Seconds: 'SECONDS',
  PlayNow: 'PLAY_NOW',
  Demo: 'DEMO',
  Play: 'PLAY',
  Payout: 'PAYOUT',
  Chance: 'CHANCE',
  ResultId: 'RESULT_ID',
  Results: 'RESULTS',
  Pf: 'PF',
  Soon: 'SOON',
  Odd: 'ODD',
  Chat: 'CHAT',
  Cancel: 'CANCEL',
  Highest: 'TOP_ODDS',
  CashOut: 'CASHOUT',
  Min: 'MIN',
  Max: 'MAX',
  AllIn: 'ALL_IN',
  Under: 'UNDER',
  Over: 'OVER',
  About: 'ABOUT',
  AutoBet: 'AUTO_BET',
  BetTypes: 'BET_TYPES',
  Markets: 'MARKETS',
  Ranges: 'RANGES',
  Manual: 'MANUAL',
  GameResult: 'GAME_RESULT',
  Bet_1: 'BET_1',
  Me: 'ME',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  Rtp: 'RTP',
  GO: 'GO',
  RoundId: 'ROUND_ID',
  PlaceYourBets: 'PLACE_YOUR_BETS',
  YouWin: 'YOU_WIN',
  PLACE_YOUR_BETS: 'PLACE_YOUR_BETS',
  BETS_ARE_CLOSING: 'BETS_ARE_CLOSING',
  BETS_ARE_CLOSED: 'BETS_ARE_CLOSED',
  LastValueRounds: 'LAST_VALUE_ROUNDS',
  ReBet: 'REBET',
  GameVersion: 'GAME_VERSION',
};

export const globalTranslationKeys = Object.assign(CoreTranslations, GameTranslationKeys);
